import { createContext, useContext } from "react";
import type { McpAppEntry } from "./useMcpAppEvents";

const EMPTY_MAP = new Map<string, McpAppEntry>();

const McpAppEntriesContext = createContext<Map<string, McpAppEntry>>(EMPTY_MAP);

export const McpAppEntriesProvider = McpAppEntriesContext.Provider;

export function useMcpAppEntries(): Map<string, McpAppEntry> {
  return useContext(McpAppEntriesContext);
}
